import request from '@/utils/request'

let UserApi = {

    /*用户登录*/
    login(data, errorback) {
        return request._post('/shop/passport/login', data, errorback);
    },
    /*退出登录*/
    loginOut(data, errorback) {
        return request._post('/shop/passport/logout', data, errorback);
    },
    /*添加用户*/
    adduser(data, errorback) {
        return request._post('/shop/user.user/add', data, errorback);
    },
    /*批量修改会员等级*/
    BatchChangegrade(data, errorback) {
      return request._post('/shop/user.user/BatchChangegrade', data, errorback);
    },
    /*批量禁用会员*/
    UserForbidden(data, errorback) {
      return request._post('/shop/user.user/UserForbidden', data, errorback);
    },
    /*批量解封会员*/
    batchRelieve(data, errorback) {
      return request._post('/shop/user.user/UserRelieve', data, errorback);
    },

    /*修改用户*/
    edituser(data, errorback) {
        return request._post('/shop/user.user/edit', data, errorback);
    },

    /*修改用户*/
    editAdd(data, errorback) {
        return request._post('/shop/user.user/editAdd', data, errorback);
    },

    /*充值*/
    userRecharge(data, errorback) {
        return request._post('/shop/user.user/recharge', data, errorback);
    },
    /*删除用户*/
    deleteuser(data, errorback) {
        return request._post('/shop/user.user/delete', data, errorback);
    },

    /*用户列表*/
    userlist(data, errorback) {
        return request._post('/shop/user.user/index', data, errorback);
    },
    /*等级列表*/
    graelist(data, errorback) {
        return request._post('/shop/user.grade/index', data, errorback);
    },
    /*等级列表*/
    gradeOrderList(data, errorback) {
        return request._post('/shop/user.grade/order', data, errorback);
    },
    /*添加等级*/
    addgrade(data, errorback) {
        return request._post('/shop/user.grade/add', data, errorback);
    },
    /*修改等级*/
    editGrade(data, errorback) {
        return request._post('/shop/user.grade/edit', data, errorback);
    },
    /*删除等级*/
    deletegrade(data, errorback) {
        return request._post('/shop/user.grade/delete', data, errorback);
    },
    /*用户余额*/
    BalanceLog(data, errorback) {
        return request._post('/shop/user.Balance/log', data, errorback);
    },
    /*充值记录*/
    RechargeOrder(data, errorback) {
        return request._post('/shop/user.Recharge/order', data, errorback);
    },
    /*修改密码*/
    EditPass(data, errorback) {
        return request._post('/shop/passport/editPass', data, errorback);
    },

    /* 新增   */

    /* 省列表 */
    provinceList(data, errorback) {
        return request._get('/shop/user.UserRegion/provinceList', data, errorback);
    },
    /* 市列表 */
    city_list(data, errorback) {
        return request._get('/shop/user.UserRegion/cityList', data, errorback);
    },
    /* 区域列表 */
    region_list(data, errorback) {
        return request._get('/shop/user.UserRegion/regionList', data, errorback);
    },
    /*  客户地区详细信息 */
    getCustomerData(data, errorback) {
        return request._post('/shop/user.UserRegion/getCustomerData', data, errorback);
    },
    /* 会员设置 */
    settingDetail(data, errorback) {
        return request._get('/shop/user.Setting/index', data, errorback);
    },
    editSetting(data, errorback) {
        return request._post('/shop/user.Setting/index', data, errorback);
    },
    /*用户关系*/
    relation(data, errorback) {
        return request._post('/shop/user.user/relation', data, errorback);
    },

}

export default UserApi;



// WEBPACK FOOTER //
// ./src/api/user.js